import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isDealRentCianAgency } from './isDealRentCianAgency';

export const isHonestAgent: TComputedPropMapper<boolean> = (props, ctx) => {
  return props.offer.user?.userTrustLevel === 'involved' || isDealRentCianAgency(props, ctx);
};
